import React, { Component } from 'react';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import BudgetSingle from './BudgetSingle';
import { isEmpty } from "lodash"
import { CloudDownloadRounded, SettingsApplicationsRounded, SettingsRounded } from '@mui/icons-material';
import BudgetActiveCat from './BudgetActiveCat';
import { GroupRadio, SingleRadio } from '../../common/RadioAndCheckbox';
import yearsToMonths from 'date-fns/esm/yearsToMonths';

class BudgetGeneral extends Component {
    state = { 
        openActiveCat: false,
        budget_year: 2022,
    }
    componentDidMount = () => {
        if(isEmpty(this.props.BUDGETS)){
            this.fetchData()
        }
        // console.log('====================================');
        // console.log(res);
        // console.log('====================================');
        
    }
    
    fetchData = (year = this.state.budget_year) => {
        this.props.fetchBudgets(year)
        this.props.fetchParentCategoriesSpent(year)
    }

    getBudgetList = () => {
        const { CATEGORIES } = this.props;
        return Object.values(CATEGORIES.PARENT).map( cat => {
            if (cat.budget_active){
                return (
                    <Grid item xs={12} sm={6} md={4}>
                        <BudgetSingle 
                            {...this.props}
                            {...this.state} 
                            category={cat}
                        />
                    </Grid>
                )
            }
        })            
    }
    handleChange = (e) => {
        // const name = e.target.name
        // const value = e.target.value
        
        // this.setState({
        //     [name]: value
        // })
        let year = parseInt(e.target.value)
        this.setState({ budget_year: year})
        this.fetchData(year)
    }

    render() {
        const { CATEGORIES } = this.props;
        const { openActiveCat, budget_year } = this.state;
        const years = ["2020", "2021", "2022"]
        // console.log('====================================');
        // console.log(this.state);
        // console.log('====================================');
        return (
            <Box>
                {openActiveCat &&
                    <BudgetActiveCat 
                        {...this.props}
                        handleClose={()=> this.setState({ openActiveCat: false})}
                    />
                }
                <Box p={1}>
                    <Typography variant="h6" >
                        Budget Annuel
                    </Typography>
                    <Box style={{textAlign: "right"}}>
                        <IconButton color="primary" onClick={() => this.props.handleDownload("/extract/categories/budget", budget_year, `MJB_budget_${budget_year}.csv`)} title="Télécharger" disabled={this.props.downloading}>
                            <CloudDownloadRounded />
                        </IconButton>
                    </Box>
                </Box>
                <Box >
                    <Box>
                        <GroupRadio name="budget_year" onChange={this.handleChange} value={budget_year}>
                            {years.map(year => 
                                <SingleRadio label={year} value={parseInt(year)} checked={budget_year === parseInt(year) }/>
                            )}
                        </GroupRadio>
                    </Box>
                    <Button 
                        // variant="contained" 
                        color="primary" 
                        onClick={() => this.setState({ openActiveCat: true })}
                        startIcon={<SettingsRounded />}
                    >
                        Catégories actives
                    </Button>
                </Box>
                <Grid container spacing={1}>
                    {!isEmpty(CATEGORIES) && !isEmpty(CATEGORIES.PARENT) && 
                        this.getBudgetList()
                    }        
                </Grid>
            </Box>
        );
    }
}

export default BudgetGeneral;